import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Ensures a URL has the correct format with a single http/https prefix
 * @param url The URL to normalize
 * @returns A properly formatted URL
 */
export function normalizeUrl(url: string): string {
  // If URL is empty or undefined, return empty string
  if (!url) return ''
  
  // If URL already starts with http:// or https://, return as is
  let normalizedUrl = url;
  if (!normalizedUrl.startsWith('http://') && !normalizedUrl.startsWith('https://')) {
    normalizedUrl = `https://${normalizedUrl}`;
  }
  
  // Check if it's a writemail.ai URL and add query parameter if it is
  if (normalizedUrl.includes('writemail.ai')) {
    // Add the query parameter, ensuring we don't add it twice or create malformed URLs
    const urlObj = new URL(normalizedUrl);
    urlObj.searchParams.set('source', 'email-signature-generator');
    return urlObj.toString();
  }
  
  // Return the normalized URL without query parameter for non-writemail.ai URLs
  return normalizedUrl;
}
